// extracted by mini-css-extract-plugin
export default {"paper":"BarcodeHeight_paper__TwcAC"};